/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Fietsvaardigheid_AchterkantInputs */

const nl_rapporten_config_elements_fietsvaardigheid_achterkant = /** @type {(inputs: Rapporten_Config_Elements_Fietsvaardigheid_AchterkantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fietsvaardigheid`)
};

/**

* @param {Rapporten_Config_Elements_Fietsvaardigheid_AchterkantInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_fietsvaardigheid_achterkant = /** @type {((inputs?: Rapporten_Config_Elements_Fietsvaardigheid_AchterkantInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Fietsvaardigheid_AchterkantInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_fietsvaardigheid_achterkant(inputs)
});
export { rapporten_config_elements_fietsvaardigheid_achterkant as "rapporten.config.elements.fietsvaardigheid_achterkant" }